import PlanCreator from "@components/PlanCreator/PlanCreator";
import { PlanCreatorProvider } from "@components/PlanCreator/PlanCreatorContext";
import styles from "./MinerPlan.module.scss";
import { useMinerContext } from "../MinerContext";
import { useEffect } from "react";


export default function MinerPlan() {

  const { miner } = useMinerContext();

  return (
    <div className={styles.miner_plan_wrapper}>
      <div className={styles.miner_plan}>
        <PlanCreatorProvider value={{
          isAllowSkipBefore: false,
          isAllowAdd: false,
          plan: miner.plan,
          disabled: true,
          readOnly: true,
        }}>
          <PlanCreator.ReadOnlyMode
            readOnly
            showTemplates={false}
            size='s'
          />
        </PlanCreatorProvider>
      </div>
    </div>
  );
}